import React, { useEffect, useState } from "react";
import { database, ref, set, onValue, off } from "../../services/firebase";
import bellSound from "../../assets/sound/bell-notification.wav";

const Patients = ({ setOpen, setRoomData }) => {
  const [patientList, setPatientList] = useState({});
  const [audio] = useState(new Audio(bellSound));

  useEffect(() => {
    const requests = ref(database, "requests/ui-kit/");
    onValue(requests, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setPatientList((prev) => {
          if (Object.keys(prev).length < Object.keys(data).length) audio.play();
          return data;
        });
      } else setPatientList({});
    });

    return () => {
      off(requests);
    };
  }, [audio]);

  const handleDeny = (id) => {
    set(ref(database, "requests/ui-kit/" + id), null);
  };

  const handleApprove = (id) => {
    const roomId = "unlimited-robotics-" + Math.floor(Math.random() * 100000);
    const password = Math.floor(Math.random() * 100000);
    setRoomData({
      participantId: id,
      roomId,
      password,
    });
    setOpen(true);

    set(ref(database, "requests/ui-kit/" + id), {
      status: "approved",
      roomId: roomId,
      password: password,
    });
  };

  return (
    <div>
      <p
        style={{
          fontSize: "32px",
          marginBottom: "20px",
        }}
      >
        Patients requesting the call:
      </p>
      {Object.keys(patientList).map((pat) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "24px",
            padding: "10px",
            borderRadius: "8px",
            background: "#2C3333",
            marginBottom: "10px",
          }}
          key={pat}
        >
          <p>{pat}</p>
          <div>
            <span
              style={{
                color: "red",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={() => handleDeny(pat)}
            >
              Deny
            </span>
            <span
              style={{
                color: "green",
                cursor: "pointer",
              }}
              onClick={() => handleApprove(pat)}
            >
              Start call
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Patients;
